import React from 'react'
import { connect } from 'react-redux'
import { setUserInfo } from '../libs/action'
import { Api } from '../libs/api'
import List from './winlist/list'

class Winlist extends React.Component {
    goRd = 0

    constructor(props) {
        super(props)
        this.state = {
            sw: '',
            sInp: '',
            isMy: false,
        }
    }

    componentDidMount() {
        Api.getUserInfo().then(rst => {
            if (rst.data.code === 200) {
                this.goRd = this.goRd + 1
                if (rst.data.isLogin) {
                    this.props.setUserInfo(rst.data.result)
                } else {
                    window.location.href = 'https://sso.pping.kr'
                }
            }
        })
    }

    shouldComponentUpdate() {
        if (this.goRd < 1) {
            this.goRd = 1
            return false
        }
        return true
    }

    wordChange = e => {
        if (e.key === 'Enter') {
            const { sInp } = this.state
            this.setState({ sw: sInp })
            return false
        }
        this.goRd = 0
        this.setState({
            [e.target.name]: e.target.value,
        })
        return true
    }

    wordClear = () => {
        document.getElementById('searchInp').value = ''
        this.setState({ sw: '' })
        return false
    }

    render() {
        const { isMy, sw, sInp } = this.state
        const sword = sw
        const sword2 = sword === '' ? '검색어를 입력해주세요.' : sw
        if (this.goRd === 0) return <p className="box-loading" />
        return (
            <section className="evtWinST">
                <article className="evtWAT evtWTop">
                    <figure className="winTit wlist">
                        <img
                            src={`${process.env.REACT_APP_CDN_IMG}/img_static/img/event/hotevt.png`}
                            alt="행복이벤트 당첨자 발표"
                        />
                        당첨자 발표
                    </figure>
                    <div className="evtTcon">
                        <div className="myAllBtns">
                            <button
                                type="button"
                                className={isMy ? 'allevtBtn' : 'allevtBtn on'}
                                onClick={() => this.setState({ isMy: false })}
                            >
                                전체
                            </button>
                            <button
                                type="button"
                                className={isMy ? 'myevtBtn on' : 'myevtBtn'}
                                onClick={() => this.setState({ isMy: true })}
                            >
                                참여한 이벤트
                            </button>
                        </div>
                        <div className="schArea">
                            <input
                                type="text"
                                className="evtWinInp"
                                name="sInp"
                                onKeyUp={this.wordChange}
                                defaultValue={sword}
                                placeholder={sword2}
                            />
                            <button
                                type="button"
                                className="icon-zoomlens"
                                onClick={() => this.setState({ sw: sInp })}
                            />
                            {sInp !== '' && <button type="button" className="icon-X_close" onClick={this.wordClear} />}
                        </div>
                    </div>
                </article>
                <article className="evtWAT evtWMain">
                    <List kWord={sw} user={this.props.userInfo} isMy={isMy} page={this.props.match.params} />
                </article>
            </section>
        )
    }
}

const stateData = state => {
    return {
        userInfo: state.user.userInfo,
    }
}

const dispatchData = dispatch => {
    return {
        setUserInfo: userInfo => dispatch(setUserInfo(userInfo)),
    }
}

export default connect(
    stateData,
    dispatchData,
)(Winlist)
